import {createSelector} from 'reselect';
import {profileReducer} from '../../profile';

export const getCouponStatistics = createSelector(
	props => props.profileCoupons,
	props => props.communityCoupons,
	props => props.source,
	props => props.couponUuid,
	(profileCoupons, communityCoupons, source, couponUuid) => {
		if (source === 'profile') {
			return profileCoupons.filter(profileCoupon => {
				return profileCoupon.uuid === couponUuid;
			});
		} else {
			return communityCoupons.filter(communityCoupon => {
				return communityCoupon.uuid === couponUuid;
			});
		}
	}
);



// WEBPACK FOOTER //
// ./src/community/coupons/coupons.selector.js